/**
* Created For: 公用搜索条
* this.$emit("input",val)  this.$emit("enter",this.keyword)  this.$emit("blur",this.keyword)
* Author: xuRui.
* Date: 2019/12/30  15:30.
*/
<template>
  <div class="feedbackBox">
    <v-title title="药店不存在或者已闭店" :isShowBack="true" :isDefaultBack="false" @backHandle="goBack();"></v-title>
    <div class="closeBox">
      <!-- <div>药店名称: {{detailData.clientName}}</div> -->
      <cube-form :model="model" @validate="validateHandler" @submit="submitHandler">
        <cube-form-group>
          <ul class="formBox">
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/name.png') " alt="">
                <p class="title-p">药店名称</p>
              </div>
              <div>
                <cube-form-item :field="fields[0]"></cube-form-item>
              </div>

            </li>
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/question.png') " alt="">
                <p class="title-p">问题描述</p>
              </div>
              <div class="textareaBox">
                <cube-form-item :field="fields[1]"></cube-form-item>
              </div>
            </li>
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/photo.png') " alt="">
                <p class="title-p">现场照片</p>
              </div>
              <div>
                <div style="padding-left:40px">
                  <cube-upload
                    ref="upload"
                    v-model="files"
                    :max="3"
                    @files-added="filesAdded"
                    :process-file="processFile"
                  >
                  </cube-upload>
                </div>
                <!--  -->
                <!-- <cube-form-item :field="fields[2]"></cube-form-item> -->
                <span class="imgShow">
                  请提供药店门脸照片，以及营业执照照片，确保门脸牌匾和营业执照字体清晰可见。
                </span>
              </div>
            </li>
          </ul>

        </cube-form-group>
        <cube-form-group>
          <cube-button type="submit" :disabled="addsubmit">提交</cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </div>
</template>
<script>
import { addFeedBack } from '@/api/feedBack'
import compress from '@/utils/compress' // compress方法用的是鹅厂的，compress.js的完整代码在本文
export default {
  name: 'CloseStore',
  components: {},
  data () {
    const self = this
    return {
      addsubmit: false,
      imgObject: [],
      imgList: [],
      value: '',
      files: [],
      detailData: {},
      valid: undefined,
      validity: {},
      photoes: [],
      model: {
        address: '', // 地址
        clientId: '', // 终端ID
        clientType: '', // 终端类型
        description: '', // 问题描述
        latitude: '', // 纬度
        longitude: '', // 经度
        name: '', // 终端名
        parentName: '', // 总部名称
        phone: '', // 电话
        photoes: [], // 照片
        type: 1, // 类型
        uploadValue: []
      },
      options: {
        scrollToInvalidField: true,
        layout: 'standard' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'name',
          props: {
            placeholder: '',
            disabled: true,
            maxlength: 50
          },
          rules: {
            required: true
          },
          // validating when blur
          trigger: 'blur'
        },
        {
          type: 'textarea',
          modelKey: 'description',
          props: {
            autoExpand: true,
            placeholder: '请输入问题描述',
            maxlength: 1000
          }

        },
        {
          type: 'upload',
          modelKey: 'uploadValue',
          props: {
            simultaneousUploads: 3,
            auto: false,

            max: 3
          },
          events: {
            'process-file': (...args) => {
              self.processFile(...args)
            },
            'file-submitted': (...args) => {
              //     console.log('..........')
              //     console.log(...args)
              const url = args[0].url
              setTimeout(function () {
                self.toast.hide()
                self.imgObject.push({ url: url, base: JSON.parse(JSON.stringify(self.imgList))[JSON.parse(JSON.stringify(self.imgList)).length - 1] })
                self.$createToast({
                  type: 'success',
                  time: 800,
                  txt: '上传成功'
                }).show()
              }, 800)
            },
            'files-added': (...args) => {
              self.toast = this.$createToast({
                txt: '正在上传。。。',
                time: 0,
                mask: false
              })
              self.toast.show()
              self.filesAdded(...args)
            },
            'file-removed': (...args) => {
              self.imgObject.forEach((item, index) => {
                if (item.url === args[0].url) {
                  self.imgObject.splice(index, 1)
                }
              })
            }
          },
          rules: {
            // uploaded: (val, config) => {
            //     return Promise.all(val.map((file, i) => {
            //     return new Promise((resolve, reject) => {
            //         if (file.uploadedUrl) {
            //         return resolve()
            //         }
            //         // fake request
            //         setTimeout(() => {
            //             if (i % 2) {
            //                 reject(new Error())
            //             } else {
            //                 file.uploadedUrl = 'uploaded/url'
            //                 resolve()
            //             }
            //         }, 1000)
            //     })
            //     })).then(() => {
            //         return true
            //     })
            // }
          },
          messages: {
            uploaded: '上传失败'
          }
        }

      ]

    }
  },
  computed: {},
  created () {
    this.detailData = JSON.parse(this.$route.query.data)
    console.log('.....传来的值.......')
    console.log(this.detailData)
    this.model.name = this.detailData.clientName
    this.model.clientType = this.detailData.thirdType
    this.model.clientId = this.detailData.matchClientId
  },
  methods: {

    // 处理原始文件函数
    processFile (file, next) {
      console.log('............')
      console.log('file1:', file.base64) // 原图片
      compress(file, {
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.2
        }
      }, (file) => {
        console.log(this.files)
        next(file)
      })
    },
    filesAdded (files) {
      let hasIgnore = false
      // 最大5M
      const maxSize = 5 * 1024 * 1024// 最大上传范围

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        // 如果选择的图片大小最大限制（这里为5M）则弹出提示
        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
          break
        }
      }
      hasIgnore && this.$createToast({
        type: 'warn',
        time: 800,
        txt: '上传图片过大'
      }).show()
    },
    // 压缩图片方法
    compressPic (bdata) {
      // 注意这里this作用域的问题
      const that = this
      // 这里quality的范围是（0-1）
      // var quality = 1;
      // for( var i = 0;i<bdata.length;i++){
      //     var canvas = document.createElement("canvas");
      //     var ctx = canvas.getContext("2d");
      //     var img = new Image();
      //     img.src = bdata[i];
      //     img.onload =function() {
      //         var width = img.width;
      //         canvas.width = width;
      //         canvas.height = width * (img.height / img.width);
      //         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      //         let data = canvas.toDataURL("image/png",quality);
      //         that.model.photoes.push(data)
      //     }
      // }
      that.model.photoes = bdata
      addFeedBack(that.model).then(res => {
        if (res.code === 1) {
          that.addsubmit = false
          that.toastsub.hide()
          that.$router.push({ name: 'feedbackSuccess' })
        } else {
          that.toastsub.hide()
        }
      })
    },
    submitHandler (e) {
      this.pushUserLog('提交反馈')
      this.addsubmit = true
      this.toastsub = this.$createToast({
        txt: '正在提交。。。',
        time: 0,
        mask: false
      }).show()

      e.preventDefault()
      this.model.photoes = []
      this.photoes = []
      for (var i = 0; i < this.files.length; i++) {
        // this.compressPic(this.imgList[i])
        this.photoes.push(this.files[i].base64)
      }
      this.compressPic(this.photoes)
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
      console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    },
    resetHandler (e) {
      console.log('reset', e)
    },

    // // 回车事件
    // submitHandle(){
    //     this.$emit("enter",this.keyword)
    // },
    // // 失去焦点时
    // blurHandle(){
    //     this.$emit("blur",this.keyword)
    // },
    pushUserLog (text) {
      // 上报操作日志
      this.$store.dispatch('PushUserLog', {
        menu: '终端地图',
        page: '终端地图',
        operation: text
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl"
    .feedbackBox{
        height 100%
        .closeBox{
            padding 32px
            padding-top 100px
            .formBox{
                li{
                    .title{
                        display flex
                        align-items  center
                        padding 20px 0
                        img{
                            width 30px
                            height 30px
                        }
                        .title-p{
                            font-size 28px
                            margin-left 30px
                            color #333333
                        }
                    }
                    .textareaBox{
                        height 200px
                        .cube-form-item{
                            padding-left 60px
                            height 100%

                        }
                    }

                }
            }
        }

        .imgShow{
            color #999999
            font-size 24px
            line-height 30px
            padding-left 60px
        }
        .cube-form-item{
            padding-left:60px
        }

    }
    .cube-textarea-wrapper{
        height 200px
        .cube-textarea{
            height 200px!important
        }
    }
    .cube-btn{
        background #5785ea
        border-radius 40px
        margin-top 30px
    }

</style>
